import { ErrorTypes } from "@wix/form-validator";
import { SupportedDateParts } from "../../utils/date-format-parts.js";
import { deserializeDate } from "../date-picker/helpers.js";
const getDatePartsErrors = (hasError, value) => {
  const { YEAR, MONTH, DAY } = deserializeDate(value);
  const invalidParts = [YEAR?.length !== 4, !MONTH, !DAY];
  const allValidParts = !invalidParts.some(Boolean);
  return {
    [SupportedDateParts.YEAR]: hasError && (allValidParts || invalidParts[0]),
    [SupportedDateParts.MONTH]: hasError && (allValidParts || invalidParts[1]),
    [SupportedDateParts.DAY]: hasError && (allValidParts || invalidParts[2])
  };
};
const isDateFieldValidationError = (error) => {
  return error?.errorType === ErrorTypes.INCOMPLETE_DATE_ERROR;
};
const getDateValidationErrorSuffix = (error) => isDateFieldValidationError(error) ? error.params.suffix : void 0;
export {
  getDatePartsErrors,
  getDateValidationErrorSuffix
};
//# sourceMappingURL=date-field-utils.js.map
